module.exports = __webpack_public_path__ + "img/66C43DCD2E51D795.aaea5362.png";